import type { Order, Route } from "@web-app/types";

import type {
  SerializableOrder,
  SerializableRoute,
} from "../workers/dispatch/types";

export function toSerializableOrder(order: Order): SerializableOrder {
  return {
    appId: order.appId ?? null,
    assigneeId: order.assigneeId || null,
    connectedWorkspaceId: order.connectedWorkspaceId || null,
    displayId: order.displayId,
    dropoffAddress: order.dropoff?.address ?? "",
    dropoffCoords: order.dropoffLocation?.coordinates
      ? [
          order.dropoffLocation.coordinates[0],
          order.dropoffLocation.coordinates[1],
        ]
      : [0, 0],
    dropoffName: order.dropoff?.name ?? "",
    dropoffStateId: order.dropoff?.stateId ?? "",
    id: order.id,
    pickupAddress: order.pickup?.address ?? "",
    pickupCoords: order.pickupLocation?.coordinates
      ? [
          order.pickupLocation.coordinates[0],
          order.pickupLocation.coordinates[1],
        ]
      : [0, 0],
    pickupName: order.pickup?.name ?? "",
    pickupStateId: order.pickup?.stateId ?? "",
    priority: order.priority,
    routeId: order.routeId ?? null,
    routeOrderIndex:
      order.route?.ordersOrder?.findIndex((r) => r.id === order.id) ?? null,
    scheduledStartDateTime:
      order.scheduledStartDateTime instanceof Date
        ? order.scheduledStartDateTime.toISOString()
        : null,
    status: order.status,
    statusText: order.statusText,
    type: order.type,
    workspaceId: order.workspaceId,
  };
}

export function toSerializableRoute(route: Route): SerializableRoute {
  return {
    assigneeId: route.assigneeId ?? null,
    connectedWorkspaceId: route.connectedWorkspaceId ?? null,
    displayId: route.displayId,
    estimatedDistance: route.estimatedDistance ?? null,
    id: route.id,
    ordersOrder: route.ordersOrder.map((o) => ({ id: o.id, index: o.index })),
    scheduledDateTime:
      route.scheduledDateTime instanceof Date
        ? route.scheduledDateTime.toISOString()
        : String(route.scheduledDateTime),
    status: route.status,
    workspaceId: route.workspaceId,
  };
}
